/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/next";
import {
  ModalDropdownMenu,
  numericPercentages,
  ScrollArea,
  ThemeProvider,
  useIsDesktopViewport,
  useTheme,
  zIndices,
} from "@packages/ui";
import type { SelectLengthListProps } from "@ui/media";
import { SelectLengthList } from "@ui/media";

import { PrayerOptionSelectTrigger } from "./PrayerOptionSelectTrigger";

type PrayerSelectLengthProps = SelectLengthListProps;

const dropdownOverModalStyle: Interpolation = {
  zIndex: zIndices.dropdownOverModal,
};
const scrollStyle: Interpolation = {
  maxHeight: "400px",
  width: numericPercentages[100],
};

const PrayerSelectLength = ({
  selectedLength,
  setSelectedLength,
  options,
}: PrayerSelectLengthProps) => {
  const isDesktop = useIsDesktopViewport();
  const t = useTranslations();
  const { renderedTheme: parentTheme } = useTheme();

  const selectedIsVideo = selectedLength?.media_type === "video";

  return (
    <ThemeProvider as={null} forceTheme={isDesktop ? "dark" : parentTheme}>
      <ModalDropdownMenu
        trigger={
          <PrayerOptionSelectTrigger
            label={t("media_options")}
            value={
              selectedLength
                ? `${selectedLength?.length} · ${t(selectedIsVideo ? "media_type_video" : "media_type_audio")}`
                : ""
            }
            disabled={options.length <= 1}
          />
        }
        contentCSS={[dropdownOverModalStyle]}
      >
        <ScrollArea horizontal={false} viewportCSS={scrollStyle}>
          <SelectLengthList
            options={options}
            selectedLength={selectedLength}
            setSelectedLength={setSelectedLength}
          />
        </ScrollArea>
      </ModalDropdownMenu>
    </ThemeProvider>
  );
};

export default PrayerSelectLength;
